import PropTypes from 'prop-types';
import HistorySection from '../../HistorySection';

export default function EmploymentSection({ employmentIncome, className = null }) {
  const { title, startDate, endDate, employer } = employmentIncome;
  const { name, phone, email, organization } = employer;
  return (
    <HistorySection
      startDate={startDate}
      endDate={endDate}
      body={[title, organization]}
      className={className}
      contactInfo={{ title: 'Employer Contact', name, phone, email }}
    />
  );
}

EmploymentSection.propTypes = {
  employmentIncome: PropTypes.shape({
    title: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    employer: PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      organization: PropTypes.string.isRequired,
    }),
  }),
  className: PropTypes.string,
};
